import { parseAgrEnvironment } from '@next/core-lib/environment';

import { Environment } from './environment.model';

const parseCSV = (value?: string): string[] =>
  value
    ? value
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
    : [];

const parseBoolean = (value?: string): boolean => value === 'true';

/**
 * Parse environment variables including app-specific runtime variables.
 */
export const parseMySiteEnvironment = (config: Record<string, string>): Environment => {
  const baseEnvironment = parseAgrEnvironment(config);

  return {
    ...baseEnvironment,
    LEGACY_URL: config.LEGACY_URL,
    MESTPLACE_URL: config.MESTPLACE_URL,
    GRAIN_REGISTRATION_URL: config.GRAIN_REGISTRATION_URL,
    IDENTIFICATION_TYPES_NL: parseCSV(config.IDENTIFICATION_TYPES_NL),
    IDENTIFICATION_WARNING_PERIOD: config.IDENTIFICATION_WARNING_PERIOD,
    RUSH_RETURN: parseBoolean(config.RUSH_RETURN),
    USE_SHOP_FOR_CART: parseBoolean(config.USE_SHOP_FOR_CART),
    HELP_NL_URL: config.HELP_NL_URL,
    REGENERATIVE_AGRICULTURE_WORKSPACE_ID: config.REGENERATIVE_AGRICULTURE_WORKSPACE_ID,
    REGENERATIVE_AGRICULTURE_REPORT_ID: config.REGENERATIVE_AGRICULTURE_REPORT_ID,
    BONDA_OBC_WORKSPACE_ID: config.BONDA_OBC_WORKSPACE_ID,
    BONDA_OBC_REPORT_ID: config.BONDA_OBC_REPORT_ID,
    CO2_IMPACT_WORKSPACE_ID: config.CO2_IMPACT_WORKSPACE_ID,
    CO2_IMPACT_REPORT_ID: config.CO2_IMPACT_REPORT_ID,
    CO2_DELIVERIES_WORKSPACE_ID: config.CO2_DELIVERIES_WORKSPACE_ID,
    CO2_DELIVERIES_REPORT_ID: config.CO2_DELIVERIES_REPORT_ID,
  };
};
